import React, { useCallback, useState } from 'react';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { useApi } from 'hooks/SwrCustom';
import AfasFooterActions from '../components/AfasFooterActions';
import AfasGrid from '../components/AfasGrid';
import AfasListToolbar from '../components/AfasListToolbar';
import { useAfasContext } from '../context/AfasContext';
import { AFAS_CONFLICTEN_COLUMNS, AFAS_CONFLICT_FILTER_OPTIONS,AFAS_MOCK_CONFLICTEN_ROWS } from '../constants';
import Loader from "react-loaders";

const AfasConflictenPage = () => {
    const { communityId, AfasService, refreshTabCounts } = useAfasContext();
    const [filter, setFilter] = useState('open');


    const swrKey = communityId
        ? `afas/conflicten?community_id=${communityId}&filter=${filter}`
        : null;

    const { data: response, isLoading, mutate } = useApi(swrKey);
    const rows = response?.data?.items ?? [];
    const  totalCount=response?.totalCount || 0;

    const persistAndRefresh = useCallback(
        async (action) => {
            try {
                await action();
                await mutate();
                await refreshTabCounts();
            } catch (error) {
                toast.error('Kon conflict niet opslaan');
                console.error(error);
            }
        },
        [mutate, refreshTabCounts],
    );
   
    const handleVerbergenChange = (rowId, checked) => {
        persistAndRefresh(() => AfasService.updateConflictVerbergen(rowId, checked));
    };

    const handleGekozenWaardeChange = (rowId, value) => {
        persistAndRefresh(() => AfasService.resolveConflict(rowId, value));
    };

    const conflictenColumns = AFAS_CONFLICTEN_COLUMNS.map((column) => {
        if (column.key === 'verbergen') {
            return {
                ...column,
                render: (row) => (
                  <div className="custom-checkbox status-checkbox afas-conflict-checkbox-wrap">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={!!row.verbergen}
                            onChange={(event) =>
                                handleVerbergenChange(row.id, event.target.checked)
                            }
                            aria-label={`Verbergen ${row.naam}`}
                        />
                    </div>
                ),
            };
        }
        if (column.key === 'gekozenWaarde') {
            return {
                ...column,
                render: (row) => (
                    <Input
                        type="select"
                        className="afas-conflict-select form-select form-select-sm w-50"
                        style={{height:'24px'}}
                        value={row.gekozenWaarde}
                        onChange={(event) =>
                            handleGekozenWaardeChange(row.id, event.target.value)
                        }
                        disabled={row.resolved}
                    >
                        {(row.gekozenOpties ?? []).map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Input>
                ),
            };
        }
        return column;
    });

    return (
        <Row>
            <Col md="12" lg="12">
                <Card className="main-card mb-3">
                    <CardBody className="p-3 table-responsive">
                        <div className="afas-list-page afas-list-page--toolbar-in-footer">
                            <AfasGrid
                                className="afas-grid--conflicten shadow-none"
                                columns={conflictenColumns}   
                                rows={rows}
                                totalCount={totalCount}
                                emptyMessage={
                                    isLoading
                                        ? <Loader
                                            type="ball-grid-pulse"
                                            className="mt-3 d-flex mx-auto justify-content-center"
                                        />
                                        : !communityId
                                            ? 'Selecteer een organisatie'
                                            : 'Geen conflicten gevonden'
                                }
                            />

                            <AfasFooterActions showActions={false}>
                                <AfasListToolbar compact />
                                <div
                                    className="afas-footer-bar__field afas-footer-bar__field--conflict-filter"
                                    style={{ minWidth: '180px' }}
                                >
                                    <Input
                                        type="select"
                                        className="form-select form-select-sm"
                                        value={filter}
                                        onChange={(event) => setFilter(event.target.value)}
                                        aria-label="Toon mij"
                                    >
                                        {AFAS_CONFLICT_FILTER_OPTIONS.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Input>
                                </div>
                            </AfasFooterActions>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default AfasConflictenPage;
